import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../axiosBaseQuery";

export const posVsShippedApi = createApi({
  reducerPath: "posVsShippedApi",
  baseQuery: axiosBaseQuery(),
  endpoints: (builder) => ({
    posVsShippedDropDownFilter: builder.mutation({
      query: (payload: any) => ({
        url: "/getPOSvsShippedFilteredData",
        method: "POST",
        data: payload,
      }),
    }),
    getPosVsShippedData: builder.mutation({
      query: (payload: any) => ({
        url: "/getPOSvsShippedData",
        method: "POST",
        data: payload,
      }),
    }),
  }),
});

export const {
  usePosVsShippedDropDownFilterMutation,
  useGetPosVsShippedDataMutation,
} = posVsShippedApi;
